/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type QuizAnswerDto = {
  kind: QuizAnswerDto.kind;
  /**
   * CHOICE: 정답 선택지 id 목록
   */
  correctChoiceIds?: Array<string>;
  /**
   * BOOLEAN: 정답 값 (TRUE_FALSE)
   */
  value?: boolean;
  /**
   * TEXT: 허용 정답 문자열 목록 (SHORT_ANSWER)
   */
  acceptedValues?: Array<string>;
};
export namespace QuizAnswerDto {
  export enum kind {
    CHOICE = "CHOICE",
    BOOLEAN = "BOOLEAN",
    TEXT = "TEXT",
  }
}
